require('./components/menu_desplegable');

$(document).ready(function () {
    $(window).scroll(function () {
        let scrollTop = $(this).scrollTop();
        $("header").addClass("scroll");

        if (scrollTop > 5) {
            $("header").addClass("scroll");
            $("body").addClass("scroll");
        } else {
            $("header").removeClass("scroll");
            $("body").removeClass("scroll");
        }
    });

    $("#loading").fadeOut(function () {
        $(this).remove();
    });
});

$(".menu-desplegable").on("click", function () {
    $(".menu-desplegable").toggleClass("menu-activo")
    $("#menu").toggleClass("menu-activo")
})

$(".up").on("click", function (e) {
    $([document.documentElement, document.body]).animate(
        {
            scrollTop: 0,
        },
        1000
    );
});

// setTimeout(function () { $("#loading").css("display", "none") }, 2000);